module.exports = "<footer class=\"footer\">\r\n    <div class=\"container\">\r\n        <div class=\"row\">\r\n            <div class=\"credits ml-auto\">\r\n                <span class=\"copyright\">\r\n                    © {{year | date: 'yyyy'}},  Full Stack Developer <i class=\"fa fa-heart heart\"></i>\r\n                </span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = ./src/app/shared/footer/footer.component.html
// module chunks = main